module.exports = __webpack_public_path__ + "img/illustration3.9fb37252.svg";